import { ORDER_FILTERS } from '@core/order';

import { i18n } from '@/plugins/i18n';

const { t } = i18n.global;

const OFFLINE_ORDER_MORE_INFORMATION_LINK =
  'https://irfarabi.com/blog/helium-724';

// We have same variable in lite so we must merge both variable
const ORDER_API_ERROR_DESCRIPTION = [
  'امکان ثبت سفارش در ساعت خارج از ساعت بازار وجود ندارد',
  'وضعیت گروه اجازه ارسال سفارش نمیدهد',
  'ثبت سفارش بعد از ساعت مجاز امکانپذیر نمی‌باشد.',
  'ثبت سفارش برای صندوق های سهامی و مختلط تا ساعت 12:30 امکان پذیر است.',
  'امکان ثبت سفارش در تعطیلات نمی‌باشد.',
  'وضعیت نماد اجازه ثبت سفارش را نمی دهد',
  'ثبت سفارش برای نمادهای صندوق سکه، طلا و گواهی سکه قبل از ساعت 11:30 وجود ندارد',
  'امکان ثبت درخواست بعد از پایان زمان بازار وجود ندارد',
  'امکان ثبت سفارش در پایان روز کاری وجود ندارد',
  'ثبت درخواست قبل از شروع بازار امکان پذیر نیست',
  'محدودیت عدم ثبت سفارش در ساعت بعد از 15:00 ',
  'امکان ثبت سفارش در نمادهای غیر از صندوق درآمد ثابت فرابورسی و اخزا قبل از ساعت 8:45 وجود ندارد',
  'امکان ثبت درخواست در نمادهای غیر از صندوق درآمد ثابت فرابورسی و اخزا قبل از ساعت 8:45 وجود ندارد',
  'ثبت سفارش برای این نماد تا ساعت 12:30 امکان پذیر است',
  'امکان ثبت سفارش در روزهای تعطیل وجود ندارد',
];

// We have same variable in lite so we must merge both variable
const ORDER_SOCKET_ERROR_DESCRIPTION = [
  'وضعیت نماد  اجازه این فعالیت را نمی دهد.',
  'وضعیت گروه  اجازه این فعالیت را نمی دهد.',
  'وضعیت نماد اجازه ثبت سفارش را نمی دهد',
  'ثبت سفارش برای نمادهای صندوق سکه، طلا و گواهی سکه قبل از ساعت 11:30 وجود ندارد',
  'امکان ثبت درخواست بعد از پایان زمان بازار وجود ندارد',
  'امکان ثبت سفارش در پایان روز کاری وجود ندارد',
  'ثبت درخواست قبل از شروع بازار امکان پذیر نیست',
  'محدودیت عدم ثبت سفارش در ساعت بعد از 15:00 ',
  'ثبت سفارش برای نمادهای صندوق سکه، طلا و گواهی سکه قبل از ساعت 11:30 وجود ندارد',
  'امکان ثبت سفارش در نمادهای غیر از صندوق درآمد ثابت فرابورسی و اخزا قبل از ساعت 8:45 وجود ندارد',
  'امکان ثبت درخواست در نمادهای غیر از صندوق درآمد ثابت فرابورسی و اخزا قبل از ساعت 8:45 وجود ندارد',
];

const ORDER_EXECUTION_TYPE = 'Desktop-Helium-Order';

const BASKET_ORDER_EXECUTION_TYPE = 'Desktop-Helium-Flash';

const OFFLINE_ORDER_PRICE_TYPE_OPTIONS = {
  desiredPrice: {
    value: 'desiredPrice',
    label: t('modules.order.priceType.desiredPrice.title'),
    executionType: 'Desktop-Helium-Falcon-247-Algo',
  },
  marketPrice: {
    value: 'marketPrice',
    label: t('modules.order.priceType.marketPrice.title'),
    executionType: 'Desktop-Helium-Falcon-247M-Algo',
  },
} as const;

const CONDITIONAL_ORDER_EXECUTION_TYPE =
  'Desktop-Helium-Falcon-Conditional-Algo';

const HELIUM_DEVICE_TYPE = 1; // Desktop

const MARGIN_SOURCE_CODE = {
  cash: 1,
  baseAsset: 2,
  position: 3,
};

const ORDER_FILTER_OPTIONS = Object.values(ORDER_FILTERS);

const MARGIN_SOURCE_LISTBOX_ITEMS = [
  {
    value: MARGIN_SOURCE_CODE.cash,
    label: t('option.cashAmount'),
  },
  {
    value: MARGIN_SOURCE_CODE.baseAsset,
    label: t('option.baseAsset'),
  },
  {
    value: MARGIN_SOURCE_CODE.position,
    label: t('misc.position'),
  },
];

const SLTP_ORDER_EXECUTION_TYPE = 'Desktop-Helium-Falcon-SLTPM-Algo';

const SLTP_DETAIL = {
  history: 'history',
  portfolio: 'portfolio',
  order: 'order',
};

export {
  ORDER_FILTER_OPTIONS,
  OFFLINE_ORDER_MORE_INFORMATION_LINK,
  ORDER_API_ERROR_DESCRIPTION,
  ORDER_SOCKET_ERROR_DESCRIPTION,
  ORDER_EXECUTION_TYPE,
  BASKET_ORDER_EXECUTION_TYPE,
  CONDITIONAL_ORDER_EXECUTION_TYPE,
  HELIUM_DEVICE_TYPE,
  OFFLINE_ORDER_PRICE_TYPE_OPTIONS,
  MARGIN_SOURCE_CODE,
  MARGIN_SOURCE_LISTBOX_ITEMS,
  SLTP_ORDER_EXECUTION_TYPE,
  SLTP_DETAIL,
};
